/**
 * Thin alias over the unified `useScopedSettingsCore` for the 2-scope
 * (workspace/user) value-based dialogs (Indicators, Fibonacci). It pins
 * `levels: "workspace-user"` and exposes the same surface those consumers
 * already use, so they don't carry their own scope logic. New scoped settings
 * should prefer `useScopedSettingsCore` directly.
 */
import {
  useScopedSettingsCore,
  type ScopedSettingsConfig,
  type ScopedSettings,
} from "./useScopedSettingsCore";

export type ScopedCascadeConfig<T> = Omit<ScopedSettingsConfig<T>, "levels">;
/** scopeUi is always present at workspace-user levels. */
export type ScopedCascade<T> = ScopedSettings<T> &
  Required<Pick<ScopedSettings<T>, "scopeUi">>;

export function useScopedCascade<T>(
  cfg: ScopedCascadeConfig<T>,
  open: boolean,
): ScopedCascade<T> {
  return useScopedSettingsCore<T>(
    { ...cfg, levels: "workspace-user" },
    open,
  ) as ScopedCascade<T>;
}
